import React, { useEffect, useState, useRef } from "react";
import BottomNav from "../components/BottomNav";
import Container from "../components/Container";
import Description from "../components/Description";
import FinancialHealthCheckup from "../components/FinancialHealthCheckup";
import Heading from "../components/Heading";
import Input from "../components/Input";
import PieGraph from "../components/PieGraph";
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Cell, ResponsiveContainer } from 'recharts';
import ResultInput from "../components/ResultInput";
import Toast from "../components/Toast";
import {useSelector,useDispatch} from 'react-redux'
import  { actions } from '../store/index'
import Tooltip from '@mui/material/Tooltip';
import { Button } from "@mui/material";
import YourFHC from "../components/YourFHC";
import { Link } from "react-router-dom";



const KFormater = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);

const renderCustomBarLabel = ({ payload, x, y, width, height, value }) => {
    return <text x={x + width / 2} y={y} fill="#0A1827" textAnchor="middle" dy={value < 0 ? 16 : -6} >{`${value.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}`}</text>;
};

const BH = () => {
    const counter=useSelector((state)=>state.formdata)
    const dispatch=useDispatch()
    const hasCodeExecuted = useRef(false);
    
     const [formData, setFormData] = useState({
        M1: 0,
        M2: 0,
        M3: 0,
        M4: 0,
        T1: 0,
        T2: 0,
        T3: 0,
        T4: 0,
    
    

    }) // setting form 1 data variables

    const [data,setData]=useState({
        H1: 0,
        H2: 0,
        H3: 0,
        H4: 0,
        H5: 0,
        H6: 0,
        H7: 0,
        H8: 0,
        H9: 0,
    })

    const [resultData, setResultData] = useState({
        R1: 0,
        R2: 0,
        R3: 0,
        R4: 0,
        R5: 0,
        HOC: 0,
        BR3: 0,
        R1a: 0,
        R2a: 0,
        R3a: 0,
        R4a: 0,
        R5a: 0,
        SME: 0,
    }); // setting calculated data variables


    const [Slack, setSlack] = useState(0);
    const [Slack2, setSlack2] = useState(0);
    const [Networth, setNetworth] = useState(0);

    const changeHandler = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    }; // handling input variables and updating their variables

    const dataChangeHandler = (e) => {

        setData({
            ...data,
            [e.target.id]: e.target.value
        });

     

    };

    function PMT(ir, np, pv, fv) {
        /*
        ir - interest rate per month
        np - number of periods (months)
        pv - present value
        fv - future value (residual value)
        */
        const pmt = (ir * (pv * Math.pow((ir + 1), np) + fv)) / ((ir + 1) * (Math.pow((ir + 1), np) - 1));

        return pmt;
    }


    const update=()=>
    {
        Object.keys(counter).length>0?
        setFormData(counter):
        setFormData(formData)
    }

    useEffect(() => {
        if (!hasCodeExecuted.current) {
          
    //   alert('adg')
            update()  
            // Set the flag to indicate that the code has been executed
            hasCodeExecuted.current = true;

            window.scrollTo(0, 0);

          }
       
        const { M1, M2, M3, M4, T1, T2, T3, T4, } = formData; // getting form data variables for calculations
        const {H1, H2, H3, H4, H5, H6, H7, H8, H9}=data
        const val = ((PMT(((Number(H8)) / 100) / 12, Number(H9) * 12, Number(H1), 0)) + ((Number(H4) + Number(H5) + Number(H6)) / 12))

        setResultData({
            R1: (Number(M3) / Number(M1)) * 100,
            R2: Number(T1) / (Number(M2) + Number(M3) + Number(M4)) * 100,
            R3: ((Number(T1) + Number(T2)) / (Number(T3) + Number(T4))) * 100,
            R4: (Number(T1) / (Number(M3) + Number(M4))) * 100,
            R5: (Number(M4) / Number(M1)) * 100,
            HOC: ((PMT(((Number(H8)) / 100) / 12, Number(H9) * 12, Number(H1), 0)) + ((Number(H4) + Number(H5) + Number(H6)) / 12)),
            BR3: (Number(val) / Number(H2)) * 100,
            R1a: (Number(M3) / Number(M1)) * 100,
            R2a: (Number(T1) / (Number(M2) + Number(M3) + Number(val))) * 100,
            R3a: ((Number(T1) + Number(T2)) / (Number(T3) + Number(H1) - Number(H7))) * 100,
            R4a: (Number(T1) / (Number(M3) + Number(val))) * 100,
            R5a: (Number(val) / Number(M1)) * 100,
            SME: (6 * (Number(val) + Number(M2) + Number(M3)))

        });//Computing and setting results

        setCartData([{
            name: 'Total Savings',
            value: Number(T1),
            color: "green"
        },
        {
            name: 'Investments',
            value: Number(T2),
            color: "green"
        },
        {
            name: 'Total Debt',
            value: -Number(T3),
            color: "red"
        },
        {
            name: 'Mortgage',
            value: -Number(T4),
            color: "pink"
        }]);//updating chart values

        let slack = Number(M1) - (Number(M2) + Number(M3) + Number(M4))  //setting Slack 1 value in a variable

        dispatch(actions.updateFormData(formData))

        setSlack(slack); // setting slack 
        const s = (Number(M1).toFixed(0) - Number(M2).toFixed(0) - Number(M3).toFixed(0) - Number(resultData.HOC).toFixed(0))
        setSlack2(Number(M1) - Number(M2) - Number(M3) - Number(resultData.HOC));   // setting Slack 2


        setNetworth((Number(T1) + Number(T2)) - Number(T3));  // setting Networth

    }, [formData, Slack, Slack2, resultData.HOC,data]);


    const [chartData, setCartData] = useState([{
        name: 'Total Savings',
        value: Number(formData.T1),
        color: "green"
    },
    {
        name: 'Investments',
        value: Number(formData.T2),
        color: "green"
    },
    {
        name: 'Total Debt',
        value: -Number(formData.T3),
        color: "red"
    },
    {
        name: 'Mortgage',
        value: -Number(formData.T4),
        color: "pink"
    }]); // declaring chart data

    return (
        <div className="w-full">
            <div className="bg-gradient-to-b h-72 from-primary to-patric-blue">
                <Container classes={"flex flex-col p-4 px-5 space-y-6 md:space-y-0  md:py-10 md:flex-row items-center w-full justify-between"}>
                    <div className="w-full md:w-auto">
                        <Link to='/'>
                        <img src="./assets/images/logo-white.png" alt="logo" />
                        </Link>
                    </div>
                    <h1 className="text-white font-bold text-center text-2xl md:text-4xl">Buying a Home</h1>
                    <div className="hidden md:block"></div>
                </Container>
                <div className="text-white  text-center mb:mx-0 mx-5 md:ml-40 -mt-3 md:-mt-7 text-lg md:text-2xl">A home is an investment only if you buy it financially right</div>

            </div>
            <Container classes={"-mt-24 md:-mt-32 py-10 space-y-6"}>
                <div className="flex flex-col md:flex-row items-start space-y-10 md:space-y-0 md:space-x-6">
                    <div className="flex-1 w-full md:flex md:space-x-10 md:space-y-0 space-y-10 ">
                        <div className="shadow-md p-6 bg-white space-y-6">
                            <Heading text={"Basic Financial Inputs "} icon={"financial-input"} />
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">
                                <Input type={"number"} id={"M1"} value={formData.M1} label={"Monthly Income"} onChange={changeHandler} />
                                <Input type={"number"} id={"T1"} value={formData.T1} label={"Total Savings (Liquid Funds)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M2"} value={formData.M2} label={"Monthly Expenses"} onChange={changeHandler} />
                                <Input type={"number"} id={"T2"} value={formData.T2} label={"Stocks, bonds, real estate etc."} onChange={changeHandler} />
                                <Input type={"number"} id={"M3"} value={formData.M3} label={"Monthly Debt pmt (credit card, car etc)"} onChange={changeHandler} />
                                <Input type={"number"} id={"T3"} value={formData.T3} label={"Total Debt (except mortgage)"} onChange={changeHandler} />
                                <Input type={"number"} id={"M4"} value={formData.M4} label={"Housing / Rent, Tax, Inurance"} onChange={changeHandler} />
                                <Input type={"number"} id={"T4"} value={formData.T4} label={"Mortgage Balance"} disable onChange={changeHandler} />
                            </div>


                        </div>

              <YourFHC R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Slack={Slack}/>
                      
                    




                    </div>

                </div>



                <div className="flex-1 w-full md:flex-none space-y-6">
                    <div className="shadow-md p-6 bg-white space-y-12">
                        <div className="hidden md:block">

                            <Heading text={"Housing Inputs"} icon={"financial-input"} />
                        </div>
                        <div className="block md:hidden md:px-0 md:text-center">

                            <Heading text={"Housing Inputs"} classes={' '} />
                        </div>


                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-3 gap-4 md:gap-y-8 lg:gap-x-28 md:ml-7  md:px-0">

                            <Input type={"number"} id={"H1"} value={data.H1} label={"Home Price"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H4"} value={data.H4} label={"Property Taxes (yearly)"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H7"} value={data.H7} label={"Down Payment (separated from savings)"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H2"} value={data.H2} label={"Current Rent"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H5"} value={data.H5} label={"Property Insurance (yearly)"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H8"} value={data.H8} label={"Interest Rate"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H3"} value={data.H3} label={"# of years planning to stay"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H6"} value={data.H6} label={"Property Maintenance (yearly)"} onChange={dataChangeHandler} />
                            <Input type={"number"} id={"H9"} value={data.H9} label={"Tenure (years)"} onChange={dataChangeHandler} />
                        </div>


                    </div>
                </div>

                <div className="block md:flex pt-10 px-5">

                    <div className="hidden md:block w-7/12">
                        <PieGraph heading="Current Cash Flow Distribution" subheading="Monthly Expenses vs Savings" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:hidden">
                        <PieGraph heading="Current Cash Flow Distribution" subheading="Monthly Expenses vs Savings" M1={formData.M1} M2={formData.M2} M3={formData.M3} M4={formData.M4} />
                    </div>
                    <div className="md:pl-14 mt-10 md:mt-24">
                        <Description R1={resultData.R1} R2={resultData.R2} R3={resultData.R3} R4={resultData.R4} R5={resultData.R5} Networth={Networth} />
                    </div>




                </div>



                <div className="space-y-20">

                    <div className="flex justify-between mt-5 flex-wrap md:items-stretch mx-0 md:mx-0 md:space-y-0 space-y-10 md:space-x-10">


                        {/* <ValueContainer fields={[{ label: 'Home Ownership Cost (HOC)', value: '$' + 0 }, { label: 'Current Rent', value: '$' + data.H2 }, { label: 'HOC vs Rent', value: '$' + 0 }]} /> */}

                        <div className="w-full md:flex-1  shadow-md  p-8 ">
                            <div className="px-0 md:px-20">

                                <Heading text="Buy VS Rent" classes={"text-center"} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center pt-5 pb-5 ">

                                <div className="md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Home Ownership Cost (HOC)'} value={isNaN(resultData.HOC) || resultData.HOC === Infinity ? 0 :  resultData.HOC.toFixed(0)} />
                                    <ResultInput label={'Current Rent'} value={isNaN(data.H2) || data.H2 === Infinity ? 0 :  (Number(data.H2)).toFixed(0)} />
                                    <ResultInput label={'HOC vs Rent'} value={isNaN(resultData.BR3) || resultData.BR3 === Infinity ? 0 : resultData.BR3.toFixed(2) + '%'} />

                                </div>


                            </div>
                            <div className="mt-4">
                                {isNaN(resultData.BR3) ? '' :
                                    resultData.BR3 > 1 ? <Toast color={"bg-red-devil"} description={"Your Homeownership cost will increase in your budget. This is covered (or not covered) by slack as determined in the Affordability checkup."} textcolor={"text-red-devil"} />
                                        : <Toast color={"bg-jungle-green"} description={"Your HOC is the same or less than your current housing costs. You should see no to minimal impact on your budget due to this home purchase."} textcolor={"text-jungle-green"} />}
                            </div>
                        </div>
                        <div className="w-full md:flex-1  shadow-md  p-8 ">
                            <div className="md:px-20 mt-20 md:mt-0">

                                <Heading text="Affordablity Check" classes={"text-center"} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center pt-5">

                                <div className="md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Home Ownership Cost (HOC)'} value={isNaN(resultData.HOC) || resultData.HOC === Infinity ? 0 :  resultData.HOC.toFixed(0)} />
                                    <ResultInput label={'Rent + Slack'} value={isNaN((data.H2 + Slack)) || (data.H2 + Slack) === Infinity ? 0 : (Number(data.H2) + Number(Slack)).toFixed(0)} />

                                </div>

                            </div>
                            <div className="mt-32">
                                {isNaN(resultData.HOC) ? '' :
                                    resultData.HOC > Number(data.H2) + Number(Slack) ? <Toast color={"bg-red-devil"} description={"You may not be able to afford this home without reducing your expenses or other debts"} textcolor={"text-red-devil"} />
                                        : <Toast color={"bg-jungle-green"} description={"You can comfortably afford this home with the current rent and slack in your budget."} textcolor={"text-jungle-green"} />}
                            </div>
                        </div>
                    </div>
                    <div className="h-1">

                    </div>

                    <div className="flex justify-between mt-5 flex-wrap md:items-stretch mx-0 md:mx-0 md:space-y-0 space-y-10 md:space-x-10">


                        <div className="w-full md:flex-1  shadow-md  p-8 ">
                            <div className="px-0">

                                <Heading text={`Can you afford this home comfortably?`} classes={"px-5 md:px-5"} />
                            </div>
                            <div className="flex justify-center">

                            </div>
                            <div className="flex justify-center pt-5 ">

                                <div className="md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Saving versus Expenses'} value={isNaN(resultData.R2a) || resultData.R2a === Infinity ? 0 : (Number(resultData.R2a)).toFixed(2) + '%'} />
                                    <ResultInput label={'Down Payment'} value={isNaN(data.H7) || data.H7 === Infinity ? 0 :  Number(data.H7).toFixed(0)} />
                                    <ResultInput label={'20% Of Home Price'} value={isNaN(0.2 * Number(data.H1)) || 0.2 * Number(data.H1) === Infinity ? 0 :  ((0.2 * Number(data.H1)).toFixed(0))} />

                                </div>

                            </div>
                            <div className="mt-8">
                                {isNaN(resultData.R2a) ? '' :
                                    resultData.R2a < 3 ? <Toast color={"bg-red-devil"} description={"You have insufficient savings to cover 3 months of expenses and debt payments. Buying this home can put a strain in case of an emergency."} textcolor={"text-red-devil"} />
                                        : data.H7 < 0.2 * data.H1 ?
                                            <Toast color={"bg-jungle-green"} description={`You can buy the home with $${data.H7} down payment but it may increase HOC due to PMI. Please check with your lender about various low-down payment options`} textcolor={"text-jungle-green"} />
                                            : <Toast color={"bg-jungle-green"} description={"You have emergency fund savings to cover R2a months of expenses and debt payments. Do not use this for your down payment."} textcolor={"text-jungle-green"} />
                                }
                            </div>
                        </div>
                        <div className="w-full md:flex-1  shadow-md  p-8  ">
                            <div className="px-0  mt-20 md:mt-0  " >

                                <Heading text="Do you have enough savings to make payments?" classes={"px-5 md:px-5 "} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center pt-5">

                                <div className="md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Total Savings'} value={isNaN(formData.T1) || formData.T1 === Infinity ? 0 :  (Number(formData.T1)).toFixed(0)} />
                                    <ResultInput label={'Six months of Expenses'} value={isNaN(resultData.SME) || resultData.SME === Infinity ? 0 :  Number(resultData.SME).toFixed(0)} />

                                </div>

                            </div>
                            <div className="mt-32 ">
                                {isNaN(resultData.SME) || resultData.SME === 0 ? '' :
                                    formData.T1 < resultData.SME ? <Toast color={"bg-red-devil"} description={"You have less than 6 months of savings to cover all your expenses after buying the home. Increasing these savings to at least six months of reserves to cover home costs, expenses, and other debt payments is prudent financial planning. "} textcolor={"text-red-devil"} />
                                        : <Toast color={"bg-jungle-green"} description={`Maintain the ${formData.T1} savings to at least 6 months of expenses including the monthly cost to afford this home."`} textcolor={"text-jungle-green"} />}
                            </div>
                        </div>
                    </div>
                    <div className="h-1">

                    </div>
                    <div className=" md:flex justify-between md:space-x-24">
                        <div className="w-full md:flex-1 p-5  shadow-md   ">
                            <div className="px-0">

                                <Heading text="Key Financial Measures (post-buying)" classes={"items-center px-10 md:px-4"} />
                            </div>
                            <div className="flex justify-center">


                            </div>
                            <div className="flex justify-center p-5">

                                <div className=" md:w-1/2 md:px-0 px-10 space-y-7">
                                    <ResultInput label={'Debt / Income ratio'} value={isNaN(resultData.R1a) || resultData.R1a === Infinity ? 0 : resultData.R1a.toFixed(2) + '%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"} />
                                    <ResultInput label={'Expense coverage ratio by savings'} value={isNaN(resultData.R2a) || resultData.R2a === Infinity ? 0 : resultData.R2a.toFixed(2) + '%'} tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"} />
                                    <ResultInput label={'Assets / Liabilities'} value={isNaN(resultData.R3a) || resultData.R3a === Infinity ? 0 : resultData.R3a.toFixed(2) + '%'} tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"} />
                                    <ResultInput label={'Assets / (Rent + Debt) coverage'} value={isNaN(resultData.R4a) || resultData.R4a === Infinity ? 0 : resultData.R4a.toFixed(2) + '%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "}/>
                                    <ResultInput label={'Housing cost ratio'} value={isNaN(resultData.R5a) || resultData.R5a === Infinity ? 0 : resultData.R5a.toFixed(2) + '%'} tooltip={"How much of your income is spent on housing costs? Recommended < 30% "}/>
                                    <ResultInput label={'Slack in Budget'} value={isNaN(Slack2) || Number(Slack2) < 0 || Slack2 === Infinity ? 0 : '' + Slack2.toFixed(0)} isLast  tooltip={"This is the surplus each month which can be used for goal planning"}/>


                                </div>

                            </div>
                        </div>

                        <div className="  w-full  md:w-1/2 pt-5 md:block  justify-center px-0 md:px-0 ">
                            <PieGraph heading="Cash Flow Distribution (post-buying)" subheading="Monthly Expenses vs Savings" M2={formData.M2} M3={formData.M3} HOC={resultData.HOC.toFixed(0)} slack={Slack2.toFixed(0)} />
                        </div>

                    </div>
                    <BottomNav />
                </div>
            </Container>
        </div>
    );
};

export default BH;